/* eslint-disable */
import { useDataContext } from '../context';
import React, { useEffect, useRef } from 'react';

const API_URL = import.meta.env.VITE_API_URL;

function AllKpis() {
  const { data, setData } = useDataContext();
  const hasFetched = useRef(false);

  useEffect(() => {
    if (data.allKpis && data.allKpis.length > 0) return;
    if (hasFetched.current) return;

    const fetchData = async () => {
      hasFetched.current = true;
      try {
        const response = await fetch(`${API_URL}/kpi/all`);
        const result = await response.json();
        
        setData(prev => ({ ...prev, allKpis: result.data || [] }));
      } catch (error) {
        console.error("Error fetching KPIs:", error);
        hasFetched.current = false;
      }
    };

    fetchData();
  }, []);

  return null;
}

export default AllKpis;